var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFileRouting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 2.89543 4.89543 2 6 2H14V6C14 7.10457 14.8954 8 16 8H20V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM13 12L10 8L7 12H9V20H11L11 18C11 16.8954 11.8954 16 13 16H14L14 18L18 15L14 12L14 14H13C12.2714 14 11.5883 14.1948 11 14.5351V12H13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14 2L20 8H16C14.8954 8 14 7.10457 14 6V2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8L7 12H13L10 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12L9 18C9 16.5194 9.8044 15.2267 11 14.5351V12H9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFileRouting);
export default __webpack_public_path__ + "static/media/ic_action_file_routing.2c088fa270114e3cdb1a59d81806fcaa.svg";
export { ForwardRef as ReactComponent };